import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class NetConnectionService {
  private connectionMonitor: Observable<boolean>;

  constructor() {
    this.connectionMonitor = new Observable(observer => {
      console.log('NetConnectionService: online =', window.navigator.onLine);
      observer.next(window.navigator.onLine);
      // Observe for offline events when internet connection is broken
      window.addEventListener('offline', (ev) => {
        observer.next(false);
      });

      // Observe for online events when internet connection is restored
      window.addEventListener('online', (ev) => {
        observer.next(true);
      });
    });
  }

  public monitor(): Observable<boolean> {
    return this.connectionMonitor;
  }
}
